import { ConcreteEncodable } from "./ConcreteEncodable";

import { ProducerChannelImplEncoder } from "../../encoder/ProducerChannelImplEncoder";

import * as CubiqTS from "../../index";
import { ProducerChannel } from "../ProducerChannel";

export class ProducerChannelImpl extends ConcreteEncodable implements ProducerChannel {
  public static enType: string = "com.bcdfx.service.messaging.impl.ProducerChannelImpl";

  /*FID=1*/
  public channelName: string;
  /*FID=2*/
  public channelType: CubiqTS.ChannelType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ProducerChannelImplEncoder.Instance;
    this.setEncodableType(ProducerChannelImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ProducerChannelImpl[" +
      "channelName=" +
      this.channelName +
      "channelType=" +
      this.channelType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
